import Immutable from 'immutable';

const QuickTextModel = Immutable.Record({
	id: 0,
	text: '',
	accountId: 0,
	index: 0
});

export default class QuickText extends QuickTextModel {
	id: number;
	text: string;
	index: number;
	accountId: number;

	clone() {
		return this.set('id', this.id);
	}

	static create() {
		return new QuickText({});
	}
}
